import React from 'react'

/*
 * Outlined security shield — Awareness Coverage.
 *
 * Traces the exact geometry of the DS FillSecurityShield icon
 * (components/lib/DesignSystem/Icons/FillSecurityShield) so the outlined and
 * filled shields stay the same shape; only the treatment differs.
 */
const ShieldOutlineIcon = ({ width, height, fill = '#3063FD' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.41 5.556V3.361c0-.41-.31-.875-.695-1.03L6.93 1.191a2.53 2.53 0 0 0-1.955 0L2.19 2.331c-.38.155-.69.62-.69 1.03v2.195c0 2.445 1.775 4.735 4.2 5.405.165.045.345.045.51 0 2.425-.67 4.2-2.96 4.2-5.405Z"
      stroke={fill}
      strokeWidth="0.9"
      strokeLinejoin="round"
      strokeLinecap="round"
    />
  </svg>
)

export default ShieldOutlineIcon
